import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useSupportContext } from '../../../contexts/SupportContext';
import { Avatar, Badge, Drawer } from 'antd';
import Bellicon from '../../../assets/Bellicon.jsx';
import MobileBottomBar from '../mobileBottomBar/MobileBottomBar.jsx';
import AppSidebar from '../sidebar/Sidebar.jsx';
import Notifications from '../notifications/Notifications.jsx';
import { GetNotificationApi, ClearNotificationApi } from '../../../api/request/users.js';
import toast from 'react-hot-toast';
import PlusSquareOutlined from '@ant-design/icons/PlusSquareOutlined';
import SegmentedComponent from '../../segmented/Segmented.jsx';
import MobileIbRequest from './MobileIbRequest.jsx';
import GoogleTranslate from '../../common/GoogleTranslate.jsx';
import { canSwitchIbDashboard } from '../../../utils/onboarding.js';
// import { getEnv } from '../../../utils/utils.js';

// const name = getEnv("VITE_NAME", "Fxcrm");

export default function MobileLayout({ children, ib, title }) {
    const { userDetails } = useSelector(state => state.user);
    const location = useLocation();
    const navigate = useNavigate();
    // const { callAddTicketHandler, hasHandler } = useSupportContext();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [notifications, setNotifications] = useState({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
    const [value, setValue] = useState(ib ? 'ib' : 'user');

    // Check if current page is dashboard
    const isDashboard = location.pathname === '/dashboard' || location.pathname === '/ib/dashboard';
    const showBackButton = !isDashboard && title !== "Fxcrm";
    const showIbDashboardSwitch = canSwitchIbDashboard(userDetails);

    const getNotification = async () => {
        try {
            const { data } = await GetNotificationApi();
            if (data?.success) {
                setNotifications(data?.data);
            }
        } catch (error) { }
    };

    const clearNotifications = async () => {
        try {
            const { data } = await ClearNotificationApi();
            if (data.success) {
                setNotifications({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
                toast.success(data.message);
            }
        } catch (error) { }
    };

    const handleProfileClick = () => {
        if (location.pathname.startsWith('/ib') || value === 'ib') {
            navigate('/ib/profile');
        } else {
            navigate('/profile');
        }
    };

    useEffect(() => {
        getNotification();
    }, []);

    useEffect(() => {
        setIsDrawerOpen(false);
    }, [location]);

    useEffect(() => {
        if (userDetails?.kycStatus === 'Approved') {
            if (value === 'user') navigate('/dashboard');
            else if (value === 'ib') navigate('/ib/dashboard');
        }
    }, [value]);

    return (
        <div className="mobile-layout min-h-screen bg-[#F1F5F9]">
            {/* Mobile Header */}
            {showBackButton ? (
                // Back button header for non-dashboard pages
                <div className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 flex items-center sticky top-0 z-40 justify-between">
                    <div className='flex items-center'>
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2 rounded-lg hover:bg-gray-100 transition-colors mr-3"
                        >
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <h1 className="text-lg font-semibold primary capitalize">{location.state?.title || title}</h1>
                    </div>
                    <GoogleTranslate compact />
                    {/* {location.pathname === '/support' && hasHandler() && (
                        <div
                            className='w-9 h-9 grid place-items-center rounded-xl bg-blue-100 cursor-pointer'
                            onClick={callAddTicketHandler}
                        >
                            <PlusSquareOutlined className='primary' />
                        </div>
                    )} */}
                </div>
            ) : (
                // Regular header for dashboard
                <div className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-40 relative">
                    {/* Left side - Menu and Logo */}
                    <div className="shrink-0 flex items-center">
                        <img className="h-11" src="/assets/logo/logo.png" alt="logo" />
                    </div>

                    {!ib && location.pathname === '/dashboard' && (
                        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                            <MobileIbRequest />
                        </div>
                    )}

                    {/* Right side - User/IB switch, Notifications and Profile */}
                    <div className="flex flex-wrap items-center justify-end gap-2 min-w-0">
                        {showIbDashboardSwitch && (
                            <div className="shrink-0">
                                <SegmentedComponent
                                    options={[
                                        { label: 'User', value: 'user' },
                                        { label: 'IB', value: 'ib' },
                                    ]}
                                    value={value}
                                    setValue={setValue}
                                    size="small"
                                />
                            </div>
                        )}
                        <button
                            onClick={() => setIsNotificationOpen(true)}
                            className="p-2 top-[6px] rounded-lg hover:bg-gray-100 transition-colors relative"
                        >
                            <Badge count={notifications?.unReadCount || 0} overflowCount={5}>
                                <Bellicon />
                            </Badge>
                        </button>
                        <button
                            onClick={handleProfileClick}
                            className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
                        >
                            <Avatar
                                size={32}
                                className="uppercase bg-blue-500"
                                src={userDetails?.profileImage}
                            >
                                {userDetails?.firstName?.charAt(0)}{userDetails?.lastName?.charAt(0)}
                            </Avatar>
                        </button>
                        <GoogleTranslate compact />
                    </div>
                </div>
            )}

            {/* Main Content */}
            <div className="h-[calc(100vh-160px)] min-h-fit p-4 pb-[100px]">
                {children}
            </div>

            {/* Mobile Bottom Navigation */}
            <MobileBottomBar ib={ib} />

            {/* Sidebar Drawer */}
            <Drawer
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                className="top-0 left-0 h-full w-full z-50"
                width={280}
                placement="left"
                styles={{
                    body: { padding: 0 }
                }}
            >
                <AppSidebar ib={ib} />
            </Drawer>

            {/* Notification Drawer */}
            <Drawer
                title={
                    <div className="flex justify-between items-center">
                        <p>Notifications</p>
                        <button
                            className="text-blue-500 text-sm font-medium"
                            onClick={clearNotifications}
                        >
                            Clear all
                        </button>
                    </div>
                }
                onClose={() => setIsNotificationOpen(false)}
                width={"100%"}
                open={isNotificationOpen}
                className='!bg-[#F1F5F9]'
            >
                <Notifications notifications={notifications} getNotification={getNotification} />
            </Drawer>
        </div>
    );
}